define([
	"dojo/_base/declare",
	"csi/table/Widget"
], function(declare, Table) {

	return declare(Table, {

		/**
		 * @override
		 * Default Season Archive View to Group by ref Type Node
		 */
		onCreateDefaultCustomView(cv) {
			this.inherited(arguments);
			this.setDefaultGroupAndExpand("RefNodeType", null, false);
		}

	});
});